import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSocialResponsibility } from "../../api"; // Import from api.js

// Async thunk for fetching social responsibility data
export const fetchSocialResponsibilityData = createAsyncThunk(
  "socialResponsibility/fetchSocialResponsibilityData",
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchSocialResponsibility();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch social responsibility data");
    }
  }
);

const socialResponsibilitySlice = createSlice({
  name: "socialResponsibility",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialResponsibilityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSocialResponsibilityData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSocialResponsibilityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = socialResponsibilitySlice.actions;
export default socialResponsibilitySlice.reducer;

